import { FC } from "react"
import React, { useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import DatePicker from 'react-date-picker';
//import DatePicker from "react-datepicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';


//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const EditNotification: FC = () => {
  const intl = useIntl()

  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10; // Per page show the data pagination
  const Pagesize = 10;
  const red = "red";
  const [totalItems, setTotalItems] = useState(0);
  const [categories, setCategories] = useState([]);
  const [totalpages, settotalPages] = useState(0);
  const [adminProfileList, setAdminProfileList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [eventInfo, setEventInfo] = useState([]);
  const [notificationInfo, setNotificationInfo] = useState<any>([]);

  const siteId = '2';
  const location99 = useLocation();

  const queryParams99 = new URLSearchParams(location99.search);
  const eventId = queryParams99.get('eventId');
  const notificationId = queryParams99.get('notificationId');

  const [stateData, setStateData] = useState([]);
  const [ckeventInfo, setckEventInfo] = useState<any>('');

  const [eventStartDate, setEventStartDate] = useState(new Date());
  const [eventEndDate, setEventEndDate] = useState(new Date());

  //const [notificationStartDate, setNotificationStartDate] = useState(new Date());
  //const [notificationEndDate, setNotificationEndDate] = useState(new Date());
  const [notificationStartDate, setNotificationStartDate] = useState<any>(new Date());
  const [notificationEndDate, setNotificationEndDate] = useState<any>(new Date());

  let history = useHistory();

  //const eventId = '5';
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function handleChangeEventInfoDesc(content) {
    setckEventInfo(content);
  }

  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }


  function getIndustries() {

    services.getIndustryData().then((res) => {
      //console.log(JSON.stringify(res)); 

      if (res.data) {
        setCategories(res.data.content);
      }
    });
  }

  function onChangeEventStartDate() {


  }

  function onChangeEventEndDate() {


  }



  function getNotificationById(notificationIdGet) {

    services.getNotificationById(notificationIdGet).then((res) => {
      console.log("#######################");
      console.log(JSON.stringify(res));
      if (res.data) {
        //alert(res.data.startDate)
        //setEventStartDate(res.data.startDate);
        var dtget = moment(res.data.startDate).format("YYYY-MM-DD");
        var dt = new Date(dtget);
        setNotificationStartDate(dt);

        var dtgetend = moment(res.data.endDate).format("YYYY-MM-DD");
        var dt_end = new Date(dtgetend);
        setNotificationEndDate(dt_end);

        //alert(dt);
        //setNotificationStartDate(res.data.startDate)
        //setNotificationEndDate(res.data.endDate)

        //setEventEndDate(res.data.endDate);
        $("#notification_title").val(res.data.notificationTitle);
        /*
        $('#event_company').val(res.data.companyName);
        $('#event_title').val(res.data.eventTitle);
        $('#event_date').val(res.data.eventDate);
        $('#event_address').val(res.data.eventAddress);
        $('#event_city').val(res.data.eventCity);
        $('#event_state').val(res.data.eventState);
        $('#postalcode').val(res.data.eventZip);
        $('#event_link').val(res.data.eventExternalLink);
        $('#event_type').val(res.data.eventTypeId);
        // $('#showon').val(res.data.eventZip);   
        */


        var eventIndustry = res.data.eventIndustry;
        //alert(seekingtypes)
        // console.log('***********'+jobinfoob.categoriesOfExpertise);

        setTimeout(() => {
          if (eventIndustry) {
            for (var i = 0; i < eventIndustry.length; i++) {
              //$('#categoriesofint value="'+catarray[i]+"'").prop('defaultChecked', true);
              $('input[name="categoryindustry"][value="' + eventIndustry[i] + '"]').prop('checked', true);
              $('input[name="categoryindustry"][value="' + eventIndustry[i] + '"]').attr('checked', "true");
            }
          }


        }, 1000);

        setEventInfo(res.data);
        setNotificationInfo(res.data)
        //lert(res.data.eventTitle)
        //$("#eventTitle").val(res.data.eventTitle);  
      }
    });
  }

  const submitValue = () => {
    var validateEditorTxt = 1;
    if ($('#notification_title').val() == "") {
      $("#notification_title_validMsg").show();
      $(window).scrollTop($('#notification_title_validMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#notification_title_validMsg").hide();
    }

    if (notificationStartDate == "") {
      $("#notification_startdatevalidMsg").show();
      $(window).scrollTop($('#notification_startdatevalidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#notification_startdatevalidMsg").hide();
    }

    if (new Date(notificationStartDate) > new Date(notificationEndDate)) {
      $("#dateValidMsg").show();
      $(window).scrollTop($('#dateValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#dateValidMsg").hide();
    }

    if (ckeventInfo == "") {
      $("#notificationInfoValidMsg").show();
      $(window).scrollTop($('#notificationInfoValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#notificationInfoValidMsg").hide();
    }

    if (validateEditorTxt == 0) {
      return false;
    }

    var notification_title = $("#notification_title").val();

    const requestObject = {
      "notificationId": notificationId,
      "notificationTitle": notification_title,
      "notificationDescription": ckeventInfo,
      "startDate": notificationStartDate,
      "endDate": notificationEndDate

    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminEditNotification(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#editnotificationsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editnotificationsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/notificationlist');
        }, 1000);
      }
      else {
        $("#editnotificationfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editnotificationfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);
      }

    });


  }
  useEffect(() => {

    const queryParams2 = new URLSearchParams(location99.search);
    const eventIdGet = queryParams2.get('eventId');
    const notificationIdGet = queryParams2.get('notificationId');
    //alert(eventIdGet);
    $("#notification_title_validMsg").hide();
    $(".se-dialog-tabs").hide();
    $("#notificationInfoValidMsg").hide();
    $('#notification_startdatevalidMsg').hide();
    getIndustries();
    //getEventById(eventIdGet);
    getNotificationById(notificationIdGet)
    $("#eventInfoValidMsg").hide();
    $('#eventtitleValidMsg').hide();
    $('#eventdateValidMsg').hide();
    $('#dateValidMsg').hide();
    $("#editnotificationsuccessMessage").hide();
    $('#editnotificationfailMessage').hide()
    var statesJson = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);
  }, []);
  type Props = {
    className: string
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>Edit Notification</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>

        <div className="container">
          <div className="row">


            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Notification Title</label>

                </div>

                <input type="text" id="notification_title" name="notification_title" className="form-control" placeholder="" />
                <div id="notification_title_validMsg" style={{ color: red }} className="error">Notification Title is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Even Start Date</label>

                </div>
                {/* <input type="text" id="event_date" name="event_date" className="form-control" placeholder="" />
                <div id="eventdateValidMsg" style={{ color: red }} className="error">Event Date is required.</div> */}



                <div>
                  {/* <DatePicker className="form-control react-date-picker eventStartDateCls"
                selected={setNotificationStartDate}
                 onChange={(date) => setNotificationStartDate(date)}
                 /> */}

                  <DatePicker className="form-control react-date-picker eventStartDateCls"
                    selected={notificationStartDate}
                    onChange={(date) => setNotificationStartDate(date)}

                  />
                  <div id="notification_startdatevalidMsg" style={{ color: red }} className="error">Notification Start Date is required.</div>
                </div>


              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Event End Date</label>

                </div>

                <div>

                  <DatePicker className="form-control react-date-picker eventStartDateCls"
                    selected={notificationEndDate}
                    onChange={(date) => setNotificationEndDate(date)}

                  />
                  <div id="dateValidMsg" style={{ color: red }} className="error">Notification End Date should not be less than Start Date.</div>
                  {/* <DatePicker className="form-control react-date-picker" onChange={setEventEndDate} 
                  value={setNotificationStartDate} 
                  selected={eventEndDate}
                  /> */}
                </div>

              </div>
            </div>






            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Notification Information</label>
                </div>
                {/* <h1>this is FCK editor area</h1> */}

                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="notificatiionInfoId"
                  data={notificationInfo.notificationDescription}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setckEventInfo(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeEventInfoDesc}
                  setContents={notificationInfo.notificationDescription}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="notificationInfoValidMsg" style={{ color: red }} className="error">Notification Information is required.</div>
              </div>
            </div>






            <div className="col-lg-12">
              <div className="mb-4">
                <div className="d-flex flex-column ">

                  <div className="row mt-8">






                    <div className="divider"></div>

                    <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}> Update Notification </button>



                  </div>
                </div>
                <div id="editnotificationsuccessMessage" className="alert alert-success" role="alert">Notification Updated Successfully</div>
                <div id="editnotificationfailMessage" className="alert alert-danger" role="alert">Please try again</div>
              </div>
            </div>

          </div>
        </div>
      </form>
    </>
  )
}
export { EditNotification }